const BASE_URL_POLITICIANS = '/api/collections/politicians/entries?limit=1000';

import {influenceClasses} from '../alpine-functions'

export default (government) => ({
    filter: {
        query: "",
        parties: [],
        regions: [],
        committees: [],
        russian_influence: false,
        chinese_influence: false,
        russian_positive_influence: false,
        chinese_positive_influence: false,
        sort: "random",
    },
    fuseOptions: {
        keys: ['slug', 'title'],
        minMatchCharLength: 1,
        threshold: 0.3,
    },
    dataFetched: false,
    politicians: [],
    filteredPoliticians: [],
    image: {
        width: 260,
        height: 260,
    },


    get filteredPoliticians() {
        let filteredPoliticians = [];
        if (this.filter.query.length > 0) {
            const fuse = new Fuse(this.politicians, this.fuseOptions);
            const result = fuse.search(this.filter.query);
            filteredPoliticians = result.map(list => list.item);
        } else {
            filteredPoliticians = this.politicians;
        }
        if (this.filter.parties.length) {
            filteredPoliticians = filteredPoliticians.filter(politician => {
                return this.filter.parties.includes(politician.parties.slug);
            });
        }
        if (this.filter.regions.length) {
            filteredPoliticians = filteredPoliticians.filter(politician => {
                return this.filter.regions.includes(politician.regions.slug);
            });
        }
        if (this.filter.committees.length) {
            filteredPoliticians = filteredPoliticians.filter(politician => {
                if (politician.committees) {
                    var ret = false;
                    politician.committees.forEach(committee => {
                        if (this.filter.committees.includes(committee)) {
                            ret = true;
                            return;
                        }
                    });
                    return ret;
                }
                return false
            });
        }
        if (this.filter.russian_influence) {
            filteredPoliticians = filteredPoliticians.filter(politician => politician.russian_influence);
        }

        if (this.filter.chinese_influence) {
            filteredPoliticians = filteredPoliticians.filter(politician => politician.chinese_influence);
        }

        if (this.filter.russian_positive_influence) {
            filteredPoliticians = filteredPoliticians.filter(politician => politician.russian_positive_influence);
        }

        if (this.filter.chinese_positive_influence) {
            filteredPoliticians = filteredPoliticians.filter(politician => politician.chinese_positive_influence);
        }
        if (this.filter.sort != "") {
            if (this.filter.sort == "random") {
                filteredPoliticians = filteredPoliticians.sort(() => Math.random() - 0.5)
            }
            else if (this.filter.sort == "alphabetically") {
                filteredPoliticians = filteredPoliticians.sort((a,b) => a.title.split(" ")[1].localeCompare(b.title.split(" ")[1]))
            }
            else if (this.filter.sort == "influence") {
                filteredPoliticians = filteredPoliticians.sort((a,b) => {
                    let aArr = [a.russian_influence, a.chinese_influence, a.russian_positive_influence, a.chinese_positive_influence];
                    let bArr = [b.russian_influence, b.chinese_influence, b.russian_positive_influence, b.chinese_positive_influence];
                    if (this.filter.russian_influence && !this.filter.chinese_influence && !this.filter.chinese_positive_influence) {
                        if (b.russian_influence - a.russian_influence === 0) {
                            return this.maxSort(aArr, bArr);
                        }
                        return b.russian_influence - a.russian_influence;
                    }
                    if (this.filter.chinese_influence && !this.filter.russian_influence && !this.filter.russian_positive_influence) {
                        if (b.chinese_influence - a.chinese_influence === 0) {
                            return this.maxSort(aArr, bArr);
                        }
                        return b.chinese_influence - a.chinese_influence;
                    }
                    if (this.filter.russian_positive_influence && !this.filter.chinese_positive_influence && !this.filter.chinese_influence) {
                        if (b.russian_positive_influence - a.russian_positive_influence === 0) {
                            return this.maxSort(aArr, bArr);
                        }
                        return b.russian_positive_influence - a.russian_positive_influence;
                    }
                    if (this.filter.chinese_positive_influence && !this.filter.russian_positive_influence && !this.filter.russian_influence) {
                        if (b.chinese_positive_influence - a.chinese_positive_influence === 0) {
                            return this.maxSort(aArr, bArr);
                        }
                        return b.chinese_positive_influence - a.chinese_positive_influence;
                    }
                    if( Math.max(...bArr) - Math.max(...aArr) === 0 ) {
                        return bArr.reduce((prev, curr) => prev + curr, 0) - aArr.reduce((prev, curr) => prev + curr, 0);
                    }
                    return Math.max(...bArr) - Math.max(...aArr);
                })
            }
        }
        this.$dispatch('filter:results', filteredPoliticians.length);
        return filteredPoliticians;
    },

    maxSort(aArr, bArr) {
        return bArr.reduce((prev, curr) => prev + curr, 0) - aArr.reduce((prev, curr) => prev + curr, 0);
    },

    influenceClasses(politician) {
        return influenceClasses(politician);
    },

    init() {
        this.getPoliticians();
        if (sessionStorage.getItem('filter') != null) {
            this.filter = JSON.parse(sessionStorage.getItem('filter'));
        }
    },

    getPoliticians() {
        let url = government ? BASE_URL_POLITICIANS + '&filter[is_in_government:is]=true' : BASE_URL_POLITICIANS + '&filter[is_not_in_parliament]=false';
        fetch(url)
            .then(response => response.json())
            .then((response) => {
                this.politicians = response.data.sort(() => Math.random() - 0.5);
                this.dataFetched = true;
            });
    },
})
